var _path, _path2, _path3, _path4, _path5;
function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgWater(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 120,
    height: 120,
    viewBox: "0 0 120 120",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M102 90H81C77.6925 90 75 87.3075 75 84V81C75 77.6925 77.6925 75 81 75V66H71.76C70.3875 74.85 63.315 81 54 81C44.685 81 37.6125 74.85 36.24 66H18V60H41.97L42 62.97C42.0725 70.0525 47.005 75 54 75C60.995 75 65.9275 70.0525 66 62.97L66.03 60H87V75C87 78.3075 84.3075 81 81 81V84H102V81C98.6925 81 96 78.3075 96 75V60C96 55.0375 91.9625 51 87 51H63V42H69V45H87C95.27 45 102 51.73 102 60V75C105.308 75 108 77.6925 108 81V84C108 87.3075 105.308 90 102 90ZM45 51H18V45H39V42H45V51Z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M59.6275 25.2275L57.7 22.9275C56.73 21.77 55.73 21 54 21C52.27 21 51.27 21.77 50.3 22.9275L48.3725 25.2275L43.775 21.3725L45.7025 19.0725C46.5475 18.065 49.1175 15 54.0025 15C58.8875 15 61.4575 18.065 62.3025 19.0725L64.23 21.3725L59.6325 25.2275H59.6275Z",
    fill: "currentColor"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M82.2425 39H58.7575L49.7575 30L58.7575 21H82.2425L91.2425 30L82.2425 39ZM61.2425 33H79.7575L82.7575 30L79.7575 27H61.2425L58.2425 30L61.2425 33Z",
    fill: "currentColor"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M91.815 114H91.13C88.63 113.885 86.3675 112.528 85.0775 110.363C83.765 108.163 83.645 105.48 84.755 103.183L91.5075 89.0325L98.265 103.195C99.36 105.52 99.2225 108.207 97.9 110.397C96.6075 112.537 94.36 113.882 91.8825 113.995H91.815V114ZM91.35 108H91.6625C92.28 107.952 92.6175 107.545 92.7625 107.3C92.8975 107.075 93.1775 106.475 92.8425 105.768L91.505 102.967L90.1625 105.783C89.825 106.48 90.0975 107.07 90.23 107.29C90.3775 107.537 90.7175 107.952 91.35 108Z",
    fill: "currentColor"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M49.2425 39H25.7575L16.7575 30L25.7575 21H49.2425L58.2425 30L49.2425 39ZM28.2425 33H46.7575L49.7575 30L46.7575 27H28.2425L25.2425 30L28.2425 33Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWater);
export default __webpack_public_path__ + "static/media/Water.63b62872.svg";
export { ForwardRef as ReactComponent };